import React from 'react';
import PropTypes from 'prop-types';
// Technically this is not a DetailView, but this is a custom form, and
// wrapping it into a DetailView, managing styles can stay less fragmented
import DetailView from '../Common/DetailView';
import Snackbar from 'material-ui/Snackbar';
import TextField from 'material-ui/TextField';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import ErrorSnackbar from '../Common/ErrorSnackbar';
import AppStore from '../../stores/AppStore';
import SettingStore from '../../stores/SettingStore';
import SettingActions from '../../actions/SettingActionCreator';
import { Card, CardText } from 'material-ui/Card';
import Error404 from '../Pages/Error404';

import buildContextMenu from '../Common/BuildContextMenu';

const styles = {
    textField : {
        color: 'rgb(0, 0, 0, 0.33) !important',
        backgroundColor: 'rgb(255,255,255) !important',
        paddingLeft: '8px',
        paddingRight: '8px',
    },
    hintStyle : {
        color: 'rgb(0, 0, 0, 0.33) !important',
    },
    inputStyle : {
        color: 'rgb(0, 0, 0, 0.33) !important',
    },
};

const sortBy = (left, right) => {
    if (left.fixed === right.fixed) { return 0; }
    if (left.fixed) { return 1; }
    return -1;
};

const getActions = () => [
    {
        link: '/logout',
        icon: <CancelIcon />,
        label: 'Sign out',
    },
];


const SettingList = React.createClass({

    getInitialState: function() {
        return {
            settings: [],
            actions: [],
            successMessageDuration: 1500,
            showSuccessMessage: false,
            showProgress: false,
        }
    },

    componentWillMount() {
        this._onChange();
    },

    componentDidMount: function() {
        this.listener = SettingStore.addListener(this._onChange);
        AppStore.addFormSubmitSuccessListener(this._onSettingSaved);
        SettingActions.getAll();
        this.setState({actions: buildContextMenu(getActions(), this.context.auth)});
    },

    componentWillUnmount: function() {
        this.listener.remove();
        AppStore.removeFormSubmitSuccessListener(this._onSettingSaved);
    },



    render: function() {
        if (!this.context.auth.isRootAdmin()) { return <Error404 />; }

        return (
            <DetailView
                title="Settings"
                actions={this.state.actions}
            >
                <Card className="cent-card">
                    <CardText>
                        {this.state.settings.map((setting, index) => (
                            <TextField
                                key={setting.name}
                                name={setting.name}
                                value={setting.value || ''}
                                hintText={setting.description}
                                floatingLabelText={setting.description}
                                onChange={this._handleTextfieldChange}
                                onBlur={this._handleTextfieldBlur}
                                fullWidth={true}
                                style={styles.textField}
                                hintStyle={styles.hintStyle}
                                inputStyle={styles.inputStyle}
                                disabled={setting.fixed}
                            />
                        ), this)}
                    </CardText>
                </Card>
                <Snackbar
                    open={this.state.showSuccessMessage}
                    message="Saved"
                    autoHideDuration={this.state.successMessageDuration}
                    onRequestClose={this._handleSnackbarRequestClose}
                />
                <ErrorSnackbar />
            </DetailView>
		)
    },
    _onChange: function() {
        const settings = SettingStore.getAll();
        if (settings !== undefined) {
            const copy = settings
                .sort(sortBy)
                .map((e) => ({name: e.name, value: e.value, default: e.value, description: e.description, fixed: !!e.fixed} ));
            this.setState({settings: copy});
        }
    },
    _handleTextfieldChange: function(event) {
        const settings = this.state.settings;
        const index = settings.findIndex(function(e) { return e !== undefined && e.name === event.target.name; });
        if (0 <= index) {
            settings[index].value = event.target.value;
            this.setState({settings: settings});
        }
    },
    _handleTextfieldBlur: function(event) {
        const localSetting = this.state.settings.find(function(e) { return e !== undefined && e.name === event.target.name; });
        if (localSetting && (localSetting.value !== localSetting.default)) {
            SettingActions.save(localSetting, localSetting.default);
        }
    },
    // Snackbar:
    _onSettingSaved: function() {
        this.setState({ showSuccessMessage: true });
    },
    _handleSnackbarRequestClose: function() {
        this.setState({ showSuccessMessage: false, showErrorMessage: false });
    }
});

SettingList.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default SettingList;
